import React from 'react';
import { BilateralHero } from './BilateralHero';
import { EndorsementBand } from './EndorsementBand';
import { EventsTimeline } from './EventsTimeline';
import { ValueProposition } from './ValueProposition';
import { ExploreCta } from './ExploreCta';
import { StickyHeader } from './StickyHeader';

export function BilateralHomepage() {
  return (
    <>
      <StickyHeader />
      <BilateralHero />
      <div className="homepage-sections">
        <ValueProposition />
        <EndorsementBand />
        <EventsTimeline />
        <ExploreCta />
      </div>
    </>
  );
}
